import { carouselItems } from '@/mocks/home';

export default function Carousel() {
  return (
    <section id="carousel" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">精选主题漫画专题，一网打尽热门佳作</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer group"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-accent-600 font-medium mb-1.5">{item.subtitle}</p>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}